import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Box from '@mui/material/Box';
import { memo } from 'react';
import { FilterOptions } from '../../filter.types';
import useStyles from './radioFilter.styles';

export interface RadioOption {
  label: string;
  value: string;
}

interface RadioFilterV2Props extends FilterOptions<string | null> {
  options: RadioOption[];
  value: string | null;
}

const RadioFilterV2 = ({ options, onChange, value }: RadioFilterV2Props) => {
  const { classes } = useStyles();

  return (
    <Box
      sx={{
        maxHeight: '284px',
      }}
    >
      <RadioGroup value={value} onChange={(_, value: string) => onChange(value)}>
        {options.map((option) => (
          <FormControlLabel
            className={classes.formControlLabel}
            key={option.value}
            value={option.value}
            label={option.label}
            control={<Radio size="small" className={classes.radio} color="primary" />}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default memo(RadioFilterV2);
